
export default {
  name: 'VisionSectionTitle',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
